import * as Dialog from "@radix-ui/react-dialog";
import type { ConfirmDialogTitleProps } from "./types";

export function ConfirmDialogTitle({ children }: ConfirmDialogTitleProps) {
  return (
    <div className="px-6 pt-5 pb-4 border-b border-border">
      <Dialog.Title className="text-[18px] font-semibold text-primary">
        {children}
      </Dialog.Title>
    </div>
  );
}
